module.exports = __webpack_public_path__ + "img/plan-img-03.5a2c6b7b.png";